import { api } from "./api"
import type { JsonBody, JsonResponse, paths } from "./generated"

type Res<K extends keyof paths> = JsonResponse<paths[K]["post"]>
type Body<K extends keyof paths> = JsonBody<paths[K]["post"]>

export const MFA_API_ERROR = {
	FEATURE_NOT_AVAILABLE: "FEATURE_NOT_AVAILABLE",
	RE_AUTH_INVALID: "RE_AUTH_INVALID",
	MFA_SESSION_EXPIRED: "MFA_SESSION_EXPIRED",
	MFA_INVALID_CODE: "MFA_INVALID_CODE",
	INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
	MFA_ALREADY_DISABLED: "MFA_ALREADY_DISABLED",
}

const mfaApi = api.injectEndpoints({
	endpoints: (builder) => ({
		reauthenticatePassword: builder.mutation<Res<"/api/mfa/reauthenticate/password">, Body<"/api/mfa/reauthenticate/password">>({
			query: (body) => ({
				url: "/mfa/reauthenticate/password",
				method: "POST",
				body,
			}),
		}),
		setupAuthenticator: builder.mutation<Res<"/api/mfa/totp/setup">, void>({
			query: () => ({
				url: "/mfa/totp/setup",
				method: "POST",
			}),
		}),

		enableAuthenticator: builder.mutation<Res<"/api/mfa/totp/enable">, Body<"/api/mfa/totp/enable">>({
			query: (body) => ({
				url: "/mfa/totp/enable",
				method: "POST",
				body,
			}),
			invalidatesTags: () => ["Profile"],
		}),
		disableAuthenticator: builder.mutation<Res<"/api/mfa/totp/disable">, Body<"/api/mfa/totp/disable">>({
			query: (body) => ({
				url: "/mfa/totp/disable",
				method: "POST",
				body,
			}),
			invalidatesTags: () => ["Profile"],
		}),
	}),
})

export const {
	useReauthenticatePasswordMutation,
	useSetupAuthenticatorMutation,
	useEnableAuthenticatorMutation,
	useDisableAuthenticatorMutation,
} = mfaApi
